import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LiveLessonSharedDataAccessAuthModule } from 'live-lesson/shared/data-access-auth';
import { LiveLessonSharedDataAccessAcsModule } from "live-lesson/shared/data-access-acs";
import { PcpLiveSessionSharedEffectsModule } from './effects/pcp-live-session-shared-effects.module';
import { LiveLessonSharedDataAccessCallStateModule } from "live-lesson/shared/data-access-call-state";


@NgModule({
    imports: [
        CommonModule,
        PcpLiveSessionSharedEffectsModule,
        LiveLessonSharedDataAccessAuthModule,
        LiveLessonSharedDataAccessAcsModule,
        LiveLessonSharedDataAccessCallStateModule,
    ],
})
export class LiveLessonSharedFeatureShellModule {}
